import styled from 'styled-components';

// Styles
import { hoverCapable } from '../../../../../../styles/hover';

// Styled Components
import { Container, Tr } from '../../../summaryTables/SummaryTablesStyles';

export const ContainerTable = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
  width: 100%;
`;

export const TeamsTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
  flex: 1;
  width: 100%;
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: end;
  gap: ${({ theme }) => theme.spaces.m}rem;
  div:last-child {
    flex: 1;
  }
`;

export const TrStyled = styled(Tr)`
  background-color: ${(props) => props.checked && props.theme.colors.paleGrey};
  cursor: pointer;
  
  /* Solo con puntero fino: en táctil el :hover se queda pegado tras
     el toque (ver styles/hover.ts). */
  ${hoverCapable} {
    &:hover {
      background-color: ${({ theme }) => theme.colors.paleGrey};
    }
  }
`;

export const ActionButton = styled.button`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.white};
  min-height: 4rem;
  min-width: 4rem;
  border: none;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.garnet};
  cursor: pointer;

  /* Solo con puntero fino: en táctil el :hover se queda pegado tras
     el toque (ver styles/hover.ts). */
  ${hoverCapable} {
    &:hover {
      opacity: 0.9;
    }
  }
`;

export const ActionCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  max-width: 20rem;
`;

export const Tag = styled.span`
  background-color: ${({ theme }) => theme.colors.paleGrey};
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 1rem;
  white-space: nowrap;
`;
